import videojs from "video.js"
import ahoy from "ahoy.js";

/* Setup tracking */
ahoy.configure({
  cookies: false,
  visitsUrl: "/pipe/visits",
  eventsUrl: "/pipe/events"
});

const Button = videojs.getComponent('Button');
class CtaButton extends Button {
  buildCSSClass() {
    return 'vjs-cta-button';
  }

  createEl(tag, props = {}, attributes = {}) {
    const { cta } = this.options();

    tag = 'button';

    props = Object.assign({
      innerHTML: `<a href="${cta.link}" target="_blank">${cta.text}</a> >`,
      className: this.buildCSSClass()
    }, props);

    // Add attributes for button element
    attributes = Object.assign({
      // Necessary since the default button type is "submit"
      type: 'div'
    }, attributes);

    const el = Button.prototype.createEl.call(this, tag, props, attributes);

    this.createControlTextEl(el);

    return el;
  }

  handleClick() {
    const { stats } = this.options();

    if (!stats.ctaClicked) {
      !stats.selfEmbed && ahoy.track("Clicked CTA", { video_id: stats.videoId });
      stats.ctaClicked = true;
    }
  }
}

const setupCta = (player, cta, stats) => {
  const ctaButton = new CtaButton(player, { cta, stats });
  player.addChild(ctaButton);

  player.on('timeupdate', () => {
    const previewLoop = player.hasClass("vjs-unmute-button-visible");
    if (previewLoop) {
      return;
    }

    const currentTime = player.currentTime();

    if (currentTime > cta.start) {
      player.addClass("vjs-cta-button-visible");
      if (!stats.ctaViewed) {
        !stats.selfEmbed && ahoy.track("Viewed CTA", { video_id: stats.videoId });
        stats.ctaViewed = true;
      }
    }

    if (currentTime > cta.end) {
      player.removeClass("vjs-cta-button-visible");
    }
  });
};

export { setupCta };
